<template>
    <v-dialog v-model="showDialog"
              class="select-user-dialog"
              min-width="300"
              width="600"
              transition="dialog-bottom-transition">
        <v-card class="text-primary ma-0">
            <v-card-title>
                <span>{{filterInfoString}} </span>
                <span> {{title}}</span>
            </v-card-title>

            <v-card-text class="pa-4 py-0">
                <v-btn v-for="user in filteredUsers" :key="user.id"
                       @click="selectUser(user)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    {{user.userName}}
                </v-btn>
            </v-card-text>

            <v-card-actions class="mb-2 mr-2">
                <v-spacer />
                <v-btn color="secondary"
                       variant="elevated"
                       @click="$emit('hide')">Отменить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        components: {

        },

        props: {
            title: String,
            users: Array,
            filterUsersIds: Array
        },

        emits: ["select:user", "hide"],

        data() {
            return {
                showDialog: true
            };
        },

        computed: {
            ...mapState([
                "userId"
            ]),

            filteredUsers() {
                if (!this.users) {
                    return [];
                }

                if (!this.filterUsersIds || this.filterUsersIds.length === 0) {
                    return this.users.filter(u => u.id != this.userId);
                }

                return this.users
                    .filter(u => !this.filterUsersIds.some(id => id === u.id) && u.id != this.userId);
            },

            filterInfoString() {
                if (!this.users || !this.filterUsersIds) {
                    return "";
                }

                if (this.users.length === this.filteredUsers.length) {
                    return ` (${this.users.length}) `;
                }

                return ` (${this.filteredUsers.length} / ${this.users.length}) `;
            }
        },

        watch: {
            showDialog(newValue) {
                if (newValue === false) {
                    this.$emit("hide");
                }
            }
        },

        methods: {
            selectUser(user) {
                this.$emit("select:user", user);
            }
        }
};
</script>

<style lang="scss">
    .select-user-dialog {
    }
</style>